import { calculateAgeInYears } from "../utills/calculateAgeInYears";

export const devProjects = ""

export const resume = "";
export const figmaPass = "29159";

 //experience starts
export const dob = '2021-07-01';

export const chatWarning = "🔒 Chats are recorded for safety. Please do not ask or share personal or sensitive information. The system will not provide such information.";

export const OPENAI_API_KEY="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" ; 

export const botResponses = [
    {
      keywords: ["help", "support", "assist"],
      response: "I'm here to assist you!",
    },
    {
      keywords: ["hi", "hello", "hey"],
      response: "Hello! How can I help you?",
    },
    {
      keywords: ["good", "morning", "night", "evening"],
      response: "Have a great day!",
    },
    {
      keywords: ["contact", "email", "reach", "connect"],
      response: "You can reach Raju at: rajuofficialk@gmail.com",
    },
    // {
    //   keywords: ["call", "phone", "number"],
    //   response: "Call us at: 6202429159",
    // },
    {
      keywords: ["address", "location", "where"],
      response: "He is currently living in Chandigarh, India",
    },
    {
      keywords: ["belongs", "home town", "permanent","from"],
      response: "He belongs to Sitamarhi,Bihar",
    },
    {
      keywords: ["about", "raju", "bio", "yourself", "you","software","engineer","name"],
      response: `He is a Software Engineer having ${calculateAgeInYears(dob)} years of experience.`,
    },
    {
      keywords: ["experience", "years", "worked", "background"],
      response: `Raju has over ${calculateAgeInYears(dob)} years of experience in software development, particularly with the MERN stack.`,
    },
    {
      keywords: ["skills", "tech", "technology", "tools", "stack"],
      response: "Raju specializes in the MERN stack (MongoDB, Express, React, Node.js) and also has experience with Next.js, Firebase, and RESTful APIs.",
    },
    {
      keywords: ["location", "based", "live", "from", "reside"],
      response: "Raju is originally from Tandaspur, Sitamarhi (Bihar) and has also worked from Chandigarh",
    },
    {
      keywords: ["education", "degree", "study", "college","punjab"],
      response: "Raju holds a B.Tech in Information Technology from Chandigarh Engineering College.",
    },
    {
      keywords: ["linkedin", "social", "profile"],
      response: "Here's his LinkedIn: https://www.linkedin.com/in/29159rajusingh/",
    },
    {
      keywords: ["insta","instagram","reel", "insta photo"],
      response: "Here's his Instagram: https://www.instagram.com/mr_singh_raju_/",
    },
    {
      keywords: ["project", "portfolio", "work", "demo"],
      response: "Visit his portfolio: https://raju159.netlify.app/ to see projects and work samples.",
    },
    {
      keywords: ["passion", "interests", "hobby", "focus"],
      response: "Raju is passionate about solving real-world problems through technology and building scalable web applications.",
    },
    {
      keywords: ["work location", "office", "company", "current"],
      response: "Raju is currently working @Anix Inventive Private Ltd Chandigarh."
    },
    {
      keywords: ["hindi","language", "known", "punjabi",  "bhojpuri", "english", "speak", "communicate"],
      response: "He is fluent in Hindi, English, Bhojpuri, and Punjabi. He also has excellent communication skills.",
    },    
    {
      keywords: ["bye", "goodbye", "exit","thanks","thank you","bye bye"],
      response: "Thanks for chatting! Have a great day!",
    },
  ];
  
